import { ModifierGrp } from '../models/ModifierGrp';
import { SubModifierGrp } from '../models/SubModifierGrp';

/** Checks quantity requirements only; selected items' nested groups still need validation. */
export function hasRequiredModifierQuantity(group: ModifierGrp | SubModifierGrp): boolean {
  const modifiers = (group as ModifierGrp).modifiers || (group as SubModifierGrp).subModifiers || [];
  const selectedCombos = modifiers.filter(mod => mod.qty > 0 && mod.comboOpenFlag === true);
  const combo = selectedCombos.find(mod => Number.isFinite(mod.comboItemQty) && mod.comboItemQty > 0);

  if (combo) {
    // Open-combo alternatives share a quota only when their combo quantities match.
    return selectedCombos.every(mod => mod.comboItemQty === combo.comboItemQty) &&
      selectedCombos.reduce((qty, mod) => qty + mod.qty, 0) >= combo.comboItemQty;
  }

  return group.qtyGrp >= group.minSelect;
}
